import { app } from '../app.module'
app.controller(
  'AnalyticsCtrl',
  ($rootScope, $scope, $state, $filter, localStorageService, SnsSelectTabService) => {
    // アクセスのフラグをチェックして、フラグがない場合は、ブランドにリダイレクトする
    if ($rootScope.flgAnalytics === false) {
      $state.go('brand')
    }
    // フィルタリングの対象をルートスコープに保存
    $rootScope.postTypeFilter = null
    $rootScope.messageFilter = null
    $rootScope.postTagFilter = null
    $rootScope.accountTagFilter = null
    $rootScope.hashtagFilter = null
    $rootScope.durationFilter = null
    $rootScope.followerFilter = null
    $rootScope.favoriteFilter = null
    $rootScope.accountGlobalFilter = null
    $rootScope.inFilter = null
    $scope.selectTab = selectTab

    // SNSタブのインデックスを取得
    const tabIndex = SnsSelectTabService.getTabIndex()

    // ローカルストレージに保存されているSNSの選択状態を取得
    let selectedSns = localStorageService.get('selectedSns')

    // SNSの選択状態がローカルストレージに保存されていない場合、facebookにする
    if (selectedSns === null) {
      selectedSns = 'facebook'
    }

    // ローカルストレージに保存されていたSNSの利用許可があるかチェックしたのちに、タブの選択処理を行う
    const checkedSns = SnsSelectTabService.checkLocalTab(selectedSns)

    selectTab(checkedSns)

    /**
     * タブが選択された際の処理
     * 選択されたSNSをスコープにセットし、初期化を行う
     * @param {string} selectedSns 選択されたSNS
     */
    function selectTab(selectedSns) {
      if (selectedSns !== null) {
        $scope.selectedTab = selectedSns

        switch (selectedSns) {
          case 'facebook':
            $scope.selectedTabIndex = tabIndex.facebook
            break
          case 'twitter':
            $scope.selectedTabIndex = tabIndex.twitter
            break
          case 'instagram':
            $scope.selectedTabIndex = tabIndex.instagram
            break
          case 'youtube':
            $scope.selectedTabIndex = tabIndex.youtube
            break
          case 'line':
            $scope.selectedTabIndex = tabIndex.line
            break
          case 'tiktok':
            $scope.selectedTabIndex = tabIndex.tiktok
            break
        }
      }

      // 選択したタブがundefined以外の場合、セット
      if ($scope.selectedTab !== undefined) {
        $scope.snsType = $scope.selectedTab

        // ローカルストレージにSNSの選択状態を保存
        localStorageService.set('selectedSns', $scope.selectedTab)

        let excludePostType = []

        switch ($scope.selectedTab) {
          case 'twitter':
            excludePostType = [
              'link',
              'carousel',
              'album',
              'offer',
              'note',
              'live-video',
              'rich_media',
            ]
            break

          case 'instagram':
            excludePostType = [
              'text',
              'animation-gif',
              'link',
              'carousel',
              'album',
              'offer',
              'note',
              'live-video',
              'rich_media',
            ]
            break

          case 'line':
            excludePostType = [
              'animation-gif',
              'link',
              'carousel',
              'album',
              'offer',
              'note',
              'live-video',
              'rich_media',
            ]
            break
        }

        // 指定されているタイプがSNSにあってない場合、nullにする
        if (excludePostType.indexOf($rootScope.postTypeFilter) !== -1) {
          $rootScope.postTypeFilter = null
        }

        const privateFlg = $filter('filter')($rootScope.followerFilter, '非公開')

        // youtubeではない場合 and 非公開でフィルタリング中の場合、非公開条件を削除
        if ($scope.selectedTab !== 'youtube' && privateFlg !== null && privateFlg.length > 0) {
          $rootScope.followerFilter = $rootScope.followerFilter.filter((follower) => {
            return follower !== '非公開'
          })

          if ($rootScope.followerFilter.length === 0) {
            $rootScope.followerFilter = null
          }
        }

        // キーワード検索をリセット
        $rootScope.messageFilter = null
      }
    }
  }
)
